import { useRef } from 'react';
import type ReactEChartsCore from 'echarts-for-react/lib/core';
import { getColor } from '@/helpers/utils';
import { Card } from 'react-bootstrap';
import { crawlTooltip } from '@/app/Crawl/tooltip/crawlTooltips';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import Flex from '@/components/common/Flex';
import CardChartDropDown from '@/components/common/CardChartDropDown';
import MainBarChart from '@/app/common/components/charts/BarChart';
import CustomLegent from '@/app/common/components/charts/CustomLegent';

interface CrawlHistoryRow {
  host_name: string;
  count_error?: number | null;
  count_warning?: number | null;
  count_info?: number | null;
}

interface CrawlBarCardStatusProps {
  data: CrawlHistoryRow[];
}

// نمودار فهرست وضعیت در صفحه تاریخچه خزش
const CrawlBarCardStatus = ({ data }: CrawlBarCardStatusProps) => {
  const cardRef = useRef<HTMLDivElement | null>(null);
  const chartRef = useRef<ReactEChartsCore | null>(null);
  const series = [
    {
      name: 'خطا',
      data: data
        .filter(({ count_error }) => count_error)
        .map(({ count_error }) => ({
          value: count_error
        })),
      itemStyle: {
        color: getColor('danger')
      }
    },
    {
      name: 'هشدار',
      data: data
        .filter(({ count_warning }) => count_warning)
        .map(({ count_warning }) => ({
          value: count_warning
        })),
      itemStyle: {
        color: getColor('warning')
      }
    },
    {
      name: 'اطلاعیه',
      data: data
        .filter(({ count_info }) => count_info)
        .map(({ count_info }) => ({ value: count_info })),
      itemStyle: {
        color: getColor('info'),
        borderRadius: [3, 3, 0, 0]
      }
    }
  ];
  return (
    <Card className="h-100 " ref={cardRef}>
      <FalconCardHeader
        title={
          <div>
            فهرست وضعیت
            <HelpTooltip html={crawlTooltip.crawlerOverview.cardChecklist} />
          </div>
        }
        titleTag="h6"
        className="py-2"
        light
        endEl={<CardChartDropDown cardRef={cardRef} chartRef={chartRef} />}
      />
      <Card.Body
        as={Flex}
        direction="column"
        justifyContent="between"
        className="py-3"
      >
        <MainBarChart
          chartRef={chartRef}
          height={250}
          categories={data
            .filter(({ count_error }) => count_error)
            .map(item => item.host_name)}
          series={series}
        />
      </Card.Body>
      <div className="d-flex mt-n4 mb-3 gap-2 justify-content-center pt-1 align-items-center">
        {series.map(item => (
          <CustomLegent
            key={item.name}
            name={item.name}
            chartRef={chartRef}
            color={item.itemStyle.color}
          />
        ))}
      </div>
    </Card>
  );
};
export default CrawlBarCardStatus;
